// Utility function to sort ancillaries by a given order
import { BASIC_BUNDLE_TIER, BONUS_BUNDLE_TIER, TOTAL_BUNDLE_TIER, NEW_FARE_TIER } from '../pageComponents/indexPage/constants';

export const sortAncillariesByOrder = (items, order) => {
  return [...items].sort((a, b) => {
    const indexA = order.indexOf(a.type);
    const indexB = order.indexOf(b.type);

    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }

    if (indexA !== -1) return -1;

    if (indexB !== -1) return 1;

    return 0;
  });
};

export const ancillarySortOrder = ['ONE_PERSONAL_ITEM', 'CARRY_ON_BAG', 'CHECK_IN_BAG', 'SEAT', 'PRIORITY_BOARDING', 'TRIP_FLEX'];

export const ENHANCED_TRIP_FLEX_CODE = "TP2";

// Helper function to build mobile bundle label
export const buildMobileBundleLabel = (ancillaries, bundleTier, labelMap) => {
  const labelParts = [];
  
  ancillaries.forEach((ancillary) => {
    switch(ancillary.type) {
      case 'ONE_PERSONAL_ITEM':
        if (labelMap.personalItemLabelHTML) {
          labelParts.push(labelMap.personalItemLabelHTML);
        }
        break;
      case 'CARRY_ON_BAG':
        if (labelMap.carryOnLabelHTML) {
          labelParts.push(labelMap.carryOnLabelHTML);
        }
        break;
      case 'CHECK_IN_BAG':
        if (labelMap.checkedBagLabelHTML) {
          labelParts.push(labelMap.checkedBagLabelHTML);
        }
        break;
      case 'SEAT':
      {
        const value =
          bundleTier === BASIC_BUNDLE_TIER
            ? labelMap.mainSeatOptionResponsiveLabelHTML
            : bundleTier === BONUS_BUNDLE_TIER || bundleTier === TOTAL_BUNDLE_TIER
              ? labelMap.allSeatOptionsResponsiveLabelHTML
              : labelMap.bundleSeatOptionsTitleHTML;
        if (value) {
          labelParts.push(value);
        }
      }
        break;
      case 'TRIP_FLEX':
      {
        const value =
          bundleTier === TOTAL_BUNDLE_TIER || bundleTier === NEW_FARE_TIER
            ? labelMap.enhancedTripFlexResponsiveLabelHTML
            : labelMap.tripFlexResponsiveLabelHTML;
        if (value) {
          labelParts.push(value);
        }
      }
        break;
      case 'PRIORITY_BOARDING':
      {
        const value =
          bundleTier === BONUS_BUNDLE_TIER || bundleTier === TOTAL_BUNDLE_TIER
            ? labelMap.priorityBoardingResponsiveLabelHTML
            : bundleTier === NEW_FARE_TIER ? labelMap.priorityBoardingLabelHTML : '';
        if (value) {
          labelParts.push(value);
        }
      }
        break;
      default:
        break;
    }
  });

  return 'Includes ' + labelParts.join(' + ');
};
